
import styled from 'styled-components'
import {
  Div, H4, P, Button,
} from 'konsys-ui'
import { Divider as DividerAnt } from 'antd'
import { theme, media, minMedia } from '../../../../../styles/_variables'


export const Box = styled.div`
    ${props => (!props.isFixedPosition ? `
        position: ${(props.sticky ? 'absolute' : 'relative')};
        height: calc(100% - 200px);
        margin-top: ${(props.sticky ? '20px' : '0px')};
        margin-bottom: ${(!props.sticky ? '20px' : '0px')};
        margin-left: ${(props.sticky ? '12px' : '0px')};
        top: ${props.isNotTop ? '0px' : '90px'};
        width: calc(30% - 12px);
        ${minMedia.mobileXL`
            width: 30%;
        `}
        ${media.mobileL`
            top: ${(props.isSummaryInProfile ? '0px' : '20px')};
            width: 100%;
        `}
    ` : `
        max-width: 345px;
        width: 100%;
    `)}
    ${media.tablet`
        max-width: 320px;
        width: 100%;
    `}
    ${media.mobileXL`
        max-width: 570px;
        width: 100%;
    `}
    // ${minMedia.laptop`
    //     max-width: ${props => (props.isFixedPosition && '34vw')};
    //     width: ${props => (props.isFixedPosition && '34vw')};
    // `}
    // ${minMedia.laptopL`
    //     max-width: ${props => (props.isFixedPosition && '28vw')};
    //     width: ${props => (props.isFixedPosition && '28vw')};
    // `}
    // ${minMedia.desktop`
    //     max-width: ${props => (props.isFixedPosition && '18vw')};
    //     width: ${props => (props.isFixedPosition && '18vw')};
    // `}
`

export const TitleBar = styled(Div)`
    border-bottom: 1px solid ${theme.color.grey};
    margin-bottom: 4px;
`

export const Title = styled(H4)`
    font-size: ${theme.fonts.size.extraNormal};
`

export const Label = styled.h4`
    font-size: ${theme.fonts.size.small};
    font-weight: ${theme.fonts.style.medium};
    margin-bottom: 0px !important;
    white-space: nowrap;
    margin-right: 8px;
    line-height: ${theme.fonts.size.small};
    ${media.tablet`
        font-size: ${theme.fonts.size.small} !important;
        font-weight: ${theme.fonts.style.medium} !important;
    `}
`

export const TextLabel = styled.span`
    color: #7d7c7c;
    font-size: ${theme.fonts.size.small};
    font-weight: ${theme.fonts.style.medium};
    margin-left: 8px;
    margin-right: 8px;
    white-space: nowrap;
    line-height: ${theme.fonts.size.small};
    ${media.tablet`
        font-size: ${theme.fonts.size.small} !important;
        font-weight: ${theme.fonts.style.medium} !important;
        line-height: ${theme.fonts.size.small} !important;
    `}
`
export const TextValue = styled.h4`
    color: ${theme.color.primaryColor};
    font-size: ${theme.fonts.size.small};
    font-weight: ${theme.fonts.style.medium};
    margin-bottom: 0px !important;
    text-align: right;
    word-break: break-word;
    line-height: ${theme.fonts.size.small};
    ${media.tablet`
        font-size: ${theme.fonts.size.small} !important;
        font-weight: ${theme.fonts.style.medium} !important;
        line-height: ${theme.fonts.size.small} !important;
    `}
`

export const TextUnit = styled.span`
    color: #7d7c7c;
    font-size: ${theme.fonts.size.small};
    font-weight: ${theme.fonts.style.medium};
    margin-left: 8px;
    white-space: nowrap;
    line-height: ${theme.fonts.size.small};
    ${media.tablet`
        font-size: ${theme.fonts.size.small} !important;
        font-weight: ${theme.fonts.style.medium} !important;
        line-height: ${theme.fonts.size.small} !important;
    `}
`

export const SummaryBox = styled(Div)`
    max-height: 60vh;
    overflow-y: auto;
    padding-right: 6px;
    &::-webkit-scrollbar {
        width: 3px;
    }
    &::-webkit-scrollbar-thumb {
        height: 2px;
        background: ${theme.color.primaryColor};
    }
    &::-webkit-scrollbar-track {
        background: ${theme.color.lightPaleGrey};
    }
    ${media.mobileXL`
        max-height: 60vh;
        overflow-y: auto;
    `}
`

export const RowHeader = styled.div`
  display: block;
`

export const Row = styled.div`
  display: flex;
`

export const Header = styled.div`
  color: ${theme.color.secondaryColor};
  font-size: 20px;
  font-weight: ${theme.fonts.style.medium};
  line-height: 1;
`

export const SubHeader = styled.span`
  color: ${theme.color.primaryColor};
  font-size: 24px;
  font-weight: ${theme.fonts.style.medium};
  line-height: 1;
  margin: 0px;
`

export const Divider = styled(DividerAnt)`
  margin: 4px 0px 8px;
  background: ${theme.color.grey};
  width: 100%;
  min-width: 100%;
`

export const ButtonEdit = styled(Button)`
    background-color: ${theme.color.greenPrimary};
    border-color: ${theme.color.greenPrimary};
    border-radius: 16px;
    padding: 2px 12px;
    box-shadow: 2px 2px 0px 1px rgb(${theme.color.primaryColorRGB}, 0.4) !important;
`

export const IconEdit = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  margin-top: -4px;
`

export const SectionDiv = styled(Div)`
    margin-top: 8px;
`

export const ItemDiv = styled(Div)`
`

export const ContentDiv = styled(Div)`
    margin-top: 8px;
`

export default Box



// WEBPACK FOOTER //
// ./src/pages/package-page/detail/components/summary/styled.js